// @ts-nocheck

// Statuses that open a dialog before they are saved. 'ordered' is saved right away.
export const STATUSES_WITH_DIALOG = ['followUp', 'completed', 'cancelled', 'notSold'];

export const toDateInputValue = (date = new Date()) => {
    const pad = value => String(value).padStart(2, '0');
    return `${date.getFullYear()}-${pad(date.getMonth() + 1)}-${pad(date.getDate())}`;
};

const getProductPrice = product => product?.price?.now ?? product?.price?.standard ?? product?.price?.standart ?? 0;

// One option per product on the order, used in the invoice dialog.
export const getInvoiceProductOptions = (order) => {
    const items = Array.isArray(order?.items) ? order.items : [];
    const options = items
        .filter(item => item?.product?.name)
        .map(item => ({
            productId: String(item.productId ?? item.product.productId ?? item.product.name),
            productName: item.product.name,
            price: getProductPrice(item.product) * (item.quantity || 1),
        }));

    return options.filter((option, index) => options.findIndex(other => other.productId === option.productId) === index);
};

export const getInitialStatusForm = ({ order, customerName = '', customerEmail = '', assignedTo = null }) => {
    const today = toDateInputValue();
    const [firstProduct] = getInvoiceProductOptions(order);

    return {
        followUp: {
            date: today,
            title: customerName ? `Følg op på ${customerName}` : 'Følg op',
            notes: '',
            advisorId: assignedTo?.userId || '',
            addToCalendar: true,
        },
        invoice: {
            name: customerName,
            email: customerEmail,
            invoiceDate: today,
            productId: firstProduct?.productId || '',
            amount: firstProduct ? String(firstProduct.price) : '',
            sendToBilly: true,
        },
        notSoldReasons: [],
    };
};

const parseAmount = (value) => {
    const normalised = String(value ?? '').replace(/\s/g, '').replace(',', '.');
    if (normalised === '') return NaN;
    return Number(normalised);
};

// Returns an error message for the form, or null when it can be saved.
export const validateStatusForm = (status, form) => {
    if (status === 'followUp' && !form.followUp.date) return 'Vælg en opfølgningsdato';
    if (status === 'completed') {
        if (!form.invoice.invoiceDate) return 'Vælg en fakturadato';
        if (!form.invoice.productId) return 'Vælg et produkt';
        const amount = parseAmount(form.invoice.amount);
        if (!Number.isFinite(amount) || amount < 0) return 'Indtast en gyldig pris';
    }
    if (status === 'notSold' && !form.notSoldReasons.length) return 'Vælg mindst én årsag';
    return null;
};

// Builds the statusChange body for POST /:organisationId/access/orders/:orderId/status.
export const buildStatusChange = ({ status, form, order, advisors = [] }) => {
    if (status === 'followUp') {
        const advisor = advisors.find(user => user.userId === form.followUp.advisorId);
        return {
            status,
            followUp: {
                date: form.followUp.date,
                title: form.followUp.title.trim(),
                notes: form.followUp.notes.trim(),
                advisor: advisor ? { userId: advisor.userId, name: advisor.name } : undefined,
                addToCalendar: form.followUp.addToCalendar,
            },
        };
    }

    if (status === 'completed') {
        const product = getInvoiceProductOptions(order).find(option => option.productId === form.invoice.productId);
        return {
            status,
            invoice: {
                name: form.invoice.name.trim(),
                email: form.invoice.email.trim(),
                invoiceDate: form.invoice.invoiceDate,
                productId: form.invoice.productId,
                productName: product?.productName,
                amount: parseAmount(form.invoice.amount),
                sendToBilly: form.invoice.sendToBilly,
            },
        };
    }

    if (status === 'notSold') {
        return { status, notSoldReasons: form.notSoldReasons };
    }

    return { status };
};
